import React, { useEffect, useState } from 'react'
import GenericFormHeaderComponent from '../../../genericComponents/forms/GenericFormHeaderComponent'
import { FileText, Image } from 'lucide-react';
import LanguageTranslator from '../../../locals/LanguageTranslator';

const DocumentViewerDetailsModal = (props) => {

    let {detailsModal, tableConfig} = props || {};

    let {headersData, headersType, headerKey, data, imageKey} = props.detailsModal ||  {};
    const [storeMainHeaderVal, setStoreMainHeaderVal] = useState("")

    const getGridColCount = (count = 0) => {    
        if (count < 16) {
            return 'grid-cols-4';
        } else {
            return 'grid-cols-6';
        }
    };

    useEffect(() => {
        if(headersData?.[headersType]?.[headerKey]) {
            setStoreMainHeaderVal(headersData?.[headersType]?.[headerKey]);
            delete headersData?.[headersType]?.[headerKey];
        }
    }, []);
    
    return (
        <div className='view-document-viewer-details h-full flex flex-col'>
            <GenericFormHeaderComponent
                label={{
                    contentPrimary: detailsModal?.modalLabel,
                }}
                closeModal={props.closeModal}
            />
            <div className='pb-4 h-full overflow-auto'>

                {/* Render the details here */}
                {
                    headerKey && <div className='header-details px-4 mb-4'>
                        <div>
                            <p className='mb-1 text-[10px]'>{storeMainHeaderVal || headersData?.[headersType]?.[headerKey] || ""}</p>
                            <div className='flex items-center gap-1.5'>
                                {/* <div>{detailsModal?.documentIcon || ""}</div> */}
                                <span><FileText size={20} strokeWidth={2}/></span>
                                
                                <p className='mb-0 text-base font-semibold'>{tableConfig?.customCols[headerKey] ? tableConfig?.customCols?.[headerKey]?.(data) : data?.[headerKey]}</p>
                            </div>
                        </div>
                    </div>
                }

                {/* Render the details here */}
                {
                    <div className='px-4 flex items-start gap-5'>
                        {!imageKey && data?.[imageKey] && <div className='w-auto h-[190px] aspect-square flex items-center justify-center'>
                            {/* {data?.[imageKey] ? <img src ={data?.[imageKey]}/> : <Image/>} */}
                            {data?.[imageKey] ? <img src ={data?.[imageKey]}/> : <Image strokeWidth={1} size={150}/>}
                            {/* {!data?.[imageKey] ? <img className="h-full w-full object-cover" src ={'https://letsenhance.io/static/8f5e523ee6b2479e26ecc91b9c25261e/1015f/MainAfter.jpg'}/> : <Image strokeWidth={1} size={150}/>} */}
                        </div>}
                        {Object.keys(headersData?.[headersType] || {})?.length > 0 && <div className={`w-full grid gap-4 ${Object.keys(headersData?.[headersType] || {})?.length < 16 ? 'grid-cols-4' : 'grid-cols-6'}`}>
                            {Object.keys(headersData?.[headersType] || {})?.map(key => (
                                <div>
                                    <LanguageTranslator tag='p' className='mb-0 text-[11px] text-[#4A5D7A]'>{headersData?.[headersType]?.[key] || " - "}</LanguageTranslator>
                                    <p className='mb-0 text-[13px] font-medium line-clamp-3'>{tableConfig?.customCols[key] ? tableConfig?.customCols?.[key]?.(data) : data?.[key] || '-'}</p>
                                </div>
                            ))}
                        </div>}
                    </div>
                }

            </div>

        </div>
    )
}

export default DocumentViewerDetailsModal
